import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./style.css";
import { NavigationItem } from "@/shared/models/ui-using/NavigationItem";

interface SidebarProps {
  menuItems: NavigationItem[];
  defaultMenu: string;
  onMenuChange?: (tab: string) => void;
  onToggle?: (isCollapsed: boolean) => void;
  isAdmin?: boolean;
}

const Sidebar = ({ menuItems, defaultMenu, onMenuChange, onToggle, isAdmin }: SidebarProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleMenuClick = (tab: string) => {
    onMenuChange && onMenuChange(tab);
    navigate(tab);
  };

  const toggleSidebar = () => {
    const newCollapsedState = !isCollapsed;
    setIsCollapsed(newCollapsedState);
    onToggle && onToggle(newCollapsedState);
  };

  const currentPath = location.pathname.replace("/", "");

  return (
    <>
      <div className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
        <ul className="sidebar-menu">
          {menuItems.map(
            (item) =>
              (!item.adminOnly || (item.adminOnly && isAdmin)) && (
                <li
                  key={item.key}
                  className={`sidebar-item ${currentPath === item.key || (currentPath === "" && item.key === defaultMenu) ? "active" : ""}`}
                >
                  <button className="sidebar-link" onClick={() => handleMenuClick(item.key)}>
                    <span className="sidebar-icon">{item.icon}</span>
                    <span className="sidebar-label">{item.label}</span>
                  </button>
                </li>
              )
          )}
        </ul>
      </div>
      <button className="sidebar-toggle" onClick={toggleSidebar}>
        <span className="toggle-icon">{isCollapsed ? "▶" : "◀"}</span>
      </button>
    </>
  );
};

export default Sidebar;
